import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { validateUserAddPermission } from "@/lib/api/auth"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza'
import MeterReaderForm from '@/components/forms/meter-reader-form'
import { Header } from '@/components/header'
import { Icons } from '@/components/icons'

export const Route = createFileRoute('/_home/meter-connection-settings/meter-reader/add')({
  component: AddMeterReaderPage,
})

export function AddMeterReaderPage() {
  const [showAddMeterReaderModal, setShowMeterReaderModal] =
    React.useState<boolean>(false)

  return (
    <main>
      <Button
        onClick={() => {
          if (!validateUserAddPermission()) return
          setShowMeterReaderModal(!showAddMeterReaderModal)
        }}
      >
        <Icons.add />
        Add Meter Reader
      </Button>
      <Credenza
        open={showAddMeterReaderModal}
        onOpenChange={setShowMeterReaderModal}
      >
        <CredenzaContent className="flex w-full max-w-[750px] justify-center">
          <CredenzaBody className="mx-auto w-full max-w-6xl px-4">
            <Header
              subroutes={[
                {
                  route: '/meter-connection-settings/meter-reader',
                  label: 'Meter Reader',
                },
              ]}
            >
              Add Meter Reader
            </Header>
            <MeterReaderForm
              setShowMeterReaderModal={setShowMeterReaderModal}
            />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
